// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cogDatabase16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cog-database': IconCogDatabase;
    }
}

/**
 * The icon component for the 'cogDatabase' icon
 */
export class IconCogDatabase extends IconSvg {
    public constructor() {
        super(cogDatabase16X16);
    }
}

registerIconSvg('icon-cog-database', IconCogDatabase);
export const iconCogDatabaseTag = 'nimble-icon-cog-database';
